/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This tool works in bytes and their multiples. Bit-level units (Kbps, Mbps) aren't included; divide bytes by 8 for bits.`)
};

const es_ds_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta herramienta funciona en bytes y sus múltiplos. Las unidades de nivel de bits (Kbps, Mbps) no están incluidas; divide bytes entre 8 para bits.`)
};

const de_ds_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Tool arbeitet mit Byte und deren Vielfachen. Bit-Einheiten (Kbps, Mbps) sind nicht enthalten; teilen Sie Byte durch 8, um Bit zu erhalten.`)
};

const nl_ds_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit gereedschap werkt met bytes en hun veelvouden. Bit-niveau-eenheden (Kbps, Mbps) zijn niet inbegrepen; deel bytes door 8 voor bits.`)
};

const fr_ds_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet outil fonctionne en octets et leurs multiples. Les unités au niveau des bits (Kbps, Mbps) ne sont pas incluses; divisez les octets par 8 pour obtenir les bits.`)
};

const it_ds_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo strumento funziona in B e loro multipli. Le unità a livello di bit (Kbps, Mbps) non sono incluse; dividi i B per 8 per ottenere i bit.`)
};

const pt_br2_ds_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ferramenta funciona com bytes e seus múltiplos. As unidades de nível de bit (Kbps, Mbps) não estão incluídas; divida bytes por 8 para bits.`)
};

const pt_ds_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta ferramenta funciona em bytes e seus múltiplos. As unidades ao nível de bits (Kbps, Mbps) não estão incluídas; divida bytes por 8 para bits.`)
};

const ja_ds_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このツールはバイトとその倍数で動作します。ビットレベルのユニット(Kbps、Mbps)は含まれていません。ビットについてはバイト数を8で割ってください。`)
};

const zh_ds_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本工具以字节及其倍数为单位进行换算。不包含比特级单位(Kbps、Mbps);如需比特数,将字节数除以 8 即可。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_faq2_a", locale)
	if (locale === "en") return en_ds_faq2_a(inputs)
	if (locale === "es") return es_ds_faq2_a(inputs)
	if (locale === "de") return de_ds_faq2_a(inputs)
	if (locale === "nl") return nl_ds_faq2_a(inputs)
	if (locale === "fr") return fr_ds_faq2_a(inputs)
	if (locale === "it") return it_ds_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_ds_faq2_a(inputs)
	if (locale === "pt") return pt_ds_faq2_a(inputs)
	if (locale === "ja") return ja_ds_faq2_a(inputs)
	return zh_ds_faq2_a(inputs)
};